import { __decorate } from "tslib";
import Component from 'vue-class-component';
import SimpleCrud from '@/components/SimpleCrud.vue';
import Vue from 'vue';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { INPUT_TYPES } from '@/constants/InputTypes';
import moment from 'moment';
import _ from 'lodash';
import { DAY_NAMES } from '@/constants/DayNames';
let OperatingHours = class OperatingHours extends Vue {
    /**
     * Standard operating hours
     */
    dialog = false;
    sending = false;
    hours = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
    ];
    editedItem = {};
    created() {
        this.editedItem = _.cloneDeep(this.currentStandardOperatingHours);
    }
    standardOperatingHoursHeaders = [
        {
            text: 'Den',
            value: 'number',
        },
        {
            text: 'Provoz od',
            value: 'openFrom',
        },
        {
            text: 'Provoz do',
            value: 'openTo',
        },
        {
            text: 'Pauzy od',
            value: 'pauses',
        },
    ];
    get currentStandardOperatingHours() {
        return this.$store.getters['standardOperatingHours/current'];
    }
    edit() {
        this.editedItem = _.cloneDeep(this.currentStandardOperatingHours);
        this.dialog = true;
    }
    async save() {
        this.sending = true;
        this.editedItem.data.validFrom = moment().toISOString();
        await this.$store.dispatch('standardOperatingHours/store', this.editedItem);
        this.dialog = false;
        this.sending = false;
    }
    /**
     * Special operating hours
     */
    title = 'Výjimečné provozní doby';
    storeModule = 'specialOperatingHours';
    formAddTitle = 'Nová výjimečná provozní doba';
    formEditTitle = 'Upravit výjimečnou provozní dobu';
    headers = [
        {
            text: 'Platné od',
            value: 'data.validFrom',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.DATE_AFTER],
            type: INPUT_TYPES.DATE,
        },
        {
            text: 'Platné do',
            value: 'data.validTo',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.DATE_AFTER],
            type: INPUT_TYPES.DATE,
        },
        {
            text: 'Provoz od',
            value: 'data.openFrom',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.SELECT,
            selectItems: [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
            ],
            customPrint: value => value + ':00',
        },
        {
            text: 'Provoz do',
            value: 'data.openTo',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.SELECT,
            selectItems: [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
            ],
            customPrint: value => value + ':00',
        },
        {
            text: 'Pauzy od',
            value: 'data.pauses',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.MULTIPLE_SELECT,
            selectItems: [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
            ],
            customPrint: value => value + ':00',
        },
        {
            text: '',
            value: 'actions',
            rules: [],
            type: '',
            sortable: false,
            notEditable: true,
        },
    ];
    defaultItem = {
        id: 'new-operating-hours',
        data: {
            validFrom: moment()
                .format('YYYY-MM-DD'),
            validTo: moment()
                .format('YYYY-MM-DD'),
            openFrom: 9,
            openTo: 20,
            pauses: [16],
            deletedAt: null,
        },
    };
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get dayNames() {
        return DAY_NAMES;
    }
};
OperatingHours = __decorate([
    Component({
        components: {
            SimpleCrud,
        },
    })
], OperatingHours);
export default OperatingHours;
